<template>
  <div class="war-room-post-poll-choice-voted">
    <div class="war-room-post-poll-choice-voted__value">{{ choice.value }}</div>
    <div class="war-room-post-poll-choice-voted__bar">
      <div class="war-room-post-poll-choice-voted__bar-header">
        <div class="war-room-post-poll-choice-voted__text">{{ choice.text }}</div>
        <div class="war-room-post-poll-choice-voted__count">{{ choice.votes_count }}</div>
      </div>
      <div class="war-room-post-poll-choice-voted__progress">
        <MarkIcon v-if="choice.isChosen" class="war-room-post-poll-choice-voted__chosen-marker" />
        <div class="war-room-post-poll-choice-voted__rail">
          <div :style="{ width: choice.value }" class="war-room-post-poll-choice-voted__fill" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import MarkIcon from './images/mark.vue.svg';

interface IChoiceVoted {
  value: string;
  text: string;
  isChosen: boolean;
}

export default Vue.extend({
  name: 'WarRoomPostPollChoiceVoted',
  components: {
    MarkIcon,
  },
  props: {
    choice: {
      type: Object,
      required: true,
    } as PropOptions<IChoiceVoted>,
  },
});
</script>

<style scoped lang="scss">
.war-room-post-poll-choice-voted {
  display: flex;
  align-items: center;

  &__value {
    @include body-semibold;

    color: var(--theme-color-text);
    min-width: 41px;
    text-align: center;
    margin-right: 8px;
  }

  &__text {
    @include subhead;

    color: var(--theme-color-sub-text);
    margin-bottom: 6px;
  }

  &__bar-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  &__bar {
    width: 100%;
  }

  &__count {
    @include subhead;

    color: var(--gray-50);
  }

  &__progress {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  &__chosen-marker {
    margin-right: 4px;
    flex-shrink: 0;
  }

  &__rail {
    background: var(--blue-60-a10);
    border-radius: 8px;
    height: 6px;
    width: 100%;
  }

  &__fill {
    background: var(--blue-60);
    border-radius: 8px;
    height: 100%;
  }
}
</style>
